export const services = [
    {
        "name": "Config Service",
        "url": "https://config-service.copilot.{0}.dragon.com/health",
    },
    {
        "name": "DAX Mobile Webview",
        "url": "https://dax-mobilewebview.copilot.{0}.dragon.com/health",
    },
    {
        "name": "DCPD Web Orchestration",
        "url": "https://dcpd-weborchestration.copilot.{0}.dragon.com/unibox/dragoncopilotdesktop/health",
    },
    {
        "name": "Dragon Copilot Web",
        "url": "https://dragon-copilot-web.copilot.{0}.dragon.com/unibox/dragon-copilot/health",
    },
    {
        "name": "EHR Integration Service",
        "url": "https://dragon-ehr.copilot.{0}.dragon.com/health",
    },
    {
        "name": "Feedback Service",
        "url": "https://dragon-feedback.copilot.{0}.dragon.com/health",
    },
    {
        "name": "HMS Connector",
        "url": "https://hms-connector.copilot.{0}.dragon.com/health",
    },
    {
        "name": "HMS Provisioning",
        "url": "https://hms-provisioning.copilot.{0}.dragon.com/health",
    },
    {
        "name": "HNLI Service",
        "url": "https://hnli.copilot.{0}.dragon.com/health",
    },
    {
        "name": "Interop",
        "url": "https://interop-rr.copilot.{0}.dragon.com/healthcheck",
    },
    {
        "name": "Logging Service",
        "url": "https://logging-service.copilot.{0}.dragon.com/health",
    },
    {
        "name": "AKV Service",
        "url": "https://mobileapi.copilot.{0}.dragon.com/health",
    },
    {
        "name": "Partner API",
        "url": "https://partnerapi.copilot.{0}.dragon.com/provisioning/health",
    },
    {
        "name": "Prompt Service",
        "url": "https://prompt-service.copilot.{0}.dragon.com/health",
    },
    {
        "name": "Session Service",
        "url": "https://session-service.copilot.{0}.dragon.com/dragonCopilotSession/health",
    },
    {
        "name": "Web Notification Service",
        "url": "https://wnsservice.copilot.{0}.dragon.com/web-notification-service/health",
    },
    {
        "name": "DAX Core Streaming",
        "url": "https://streaming.{0}1.daxcore.azure.com/health",
    },
];

export const countries = [
    {
        "name": "Canada",
        "code": "ca",
    },
    {
        "name": "France",
        "code": "fr",
    },
    {
        "name": "Germany",
        "code": "de",
    },
    {
        "name": "United Kingdom",
        "code": "uk2",
    },
    {
        "name": "United States",
        "code": "us",
    },
];